import "./dashboard-page.scss";

import { observer } from "mobx-react-lite";

import { NoOrdersPage, OrderTabs } from "@client/components";
import { useRootContext } from "@client/context/RootContext";

export const DashboardPage = observer(() => {
	const {
		vendorStore: { activeOrders, vendorDetails },
		layoutStore: { showSearchResults },
	} = useRootContext();
	// function onWindowFocus() {
	// 	vendorStore.getVendorAndActiveOrders();
	// }
	// useEvent("focus", () => authStore.loggedIn && onWindowFocus());

	const shouldShowNoOrdersPage =
		!showSearchResults && !!vendorDetails && !activeOrders.length;

	return shouldShowNoOrdersPage ? <NoOrdersPage /> : <OrderTabs />;
});
